/**
 * `example.com/post` is what people paste; `https://example.com/post` is what
 * the API takes. Returns `null` for anything that is not a link, which is what
 * puts the error inline instead of spending a round-trip on a `400`.
 */
export function normalizeUrl(value) {
    const candidate = /^[a-z][a-z0-9+.-]*:\/\//i.test(value) ? value : `https://${value}`;
    try {
        const url = new URL(candidate);
        // A bare word parses as a perfectly good hostname, so the dot is what
        // separates a URL from a typo. Nobody pastes `http://intranet` in here.
        return /^https?:$/.test(url.protocol) && url.hostname.includes(".") ? url.href : null;
    }
    catch {
        return null;
    }
}
export function formatBytes(bytes) {
    const gb = bytes / 1024 ** 3;
    if (gb >= 1)
        return `${gb.toFixed(1)} GB`;
    return `${Math.max(bytes / 1024 ** 2, 0.1).toFixed(1)} MB`;
}
//# sourceMappingURL=capture.js.map